import type { Selectable } from 'kysely';
import type { CappersContentblock as CappersContentBlockDB } from '$lib/types/db/db';

export const enum BlockType {
  'BIO_V1' = 'bio-v1',
  'HEADER_V1' = 'header-v1',
  'SPECIAL_OFFER_V1' = 'special-offer-v1',
  'FAQ_V1' = 'faq-v1',
  'IMAGE_V1' = 'image-v1',
  'PRODUCT_V1' = 'product-v1',
  'REVIEW_V1' = 'review-v1'
}

export const BlockTypeValues = [
  BlockType.BIO_V1,
  BlockType.HEADER_V1,
  BlockType.SPECIAL_OFFER_V1,
  BlockType.FAQ_V1,
  BlockType.IMAGE_V1,
  BlockType.PRODUCT_V1,
  BlockType.REVIEW_V1
] as const;

export enum SocialLinkType {
  'YOUTUBE' = 'youtube',
  'TWITTER' = 'twitter',
  'INSTAGRAM' = 'instagram',
  'TIKTOK' = 'tiktok',
  'DISCORD' = 'discord'
}

export enum HeaderType {
  'VIDEO' = 'video',
  'BANNER' = 'banner',
  'NONE' = 'none'
}

export interface SocialLink {
  type: SocialLinkType;
  url: string; // HttpUrl
}

export interface BioContent {
  text: string;
  social_links: SocialLink[];
}

export interface HeaderContent {
  header_type: HeaderType;
  bio?: string;
  banner_url?: string;
  video_url?: string;
}

export interface FAQItem {
  question: string;
  answer: string;
}

export interface FAQContent {
  items: FAQItem[];
}

export interface ImageItem {
  name: string;
  url: string; // HttpUrl
}

export interface ImageContent {
  images: ImageItem[];
}

export interface SpecialOfferContent {
  promo_code_id: number;
}

export interface ReviewContent {
  // No properties needed
}

type ContentType = {
  [BlockType.BIO_V1]: BioContent;
  [BlockType.HEADER_V1]: HeaderContent;
  [BlockType.FAQ_V1]: FAQContent;
  [BlockType.IMAGE_V1]: ImageContent;
  [BlockType.SPECIAL_OFFER_V1]: SpecialOfferContent;
  [BlockType.PRODUCT_V1]: Record<string, string>; // Gonna be empty for now anyways just need it for heading
  [BlockType.REVIEW_V1]: ReviewContent;
};

export interface PartnerContentBlock
  extends Omit<Selectable<CappersContentBlockDB>, 'content' | 'block_type' | 'id'> {
  id?: string;
  block_type: BlockType;
  content: ContentType[BlockType];
}
